import { __assign } from "tslib";
import * as React from 'react';
import { useEffect, useState } from 'react';
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete';
import { Field } from 'formik';
import { Error } from '../../../../../components/Error';
import { parseAddressFromGoogle } from '../../../../../common/parseAddress';
export function CheckAddress(_a) {
    var type = _a.type, label = _a.label, touched = _a.touched, errors = _a.errors, setFieldValue = _a.setFieldValue, values = _a.values, streetTypes = _a.streetTypes, levelTypes = _a.levelTypes, unitTypes = _a.unitTypes, states = _a.states;
    var _b = useState(false), gmapsLoaded = _b[0], setGmapsLoaded = _b[1];
    var _c = useState({
        addressSelected: false,
        autoCompleteAddress: '',
        manualAddressEntry: false,
    }), address = _c[0], setAddress = _c[1];
    useEffect(function () {
        ;
        window.initMaps = initMaps;
        insertGoogleMapsScript();
        if (values[type + "AddressStreetNumber"] && values[type + "AddressState"]) {
            setAddress(__assign(__assign({}, address), { manualAddressEntry: true }));
        }
    }, []);
    var onRetryClick = function () {
        setGmapsLoaded(true);
    };
    var handleAddressChange = function (autoCompleteAddress) {
        setAddress(__assign(__assign({}, address), { autoCompleteAddress: autoCompleteAddress }));
    };
    var handleAddressSelect = function (autoCompleteAddress) {
        if (gmapsLoaded && autoCompleteAddress) {
            geocodeByAddress(autoCompleteAddress).then(function (places) {
                var place = places[0];
                var address = parseAddressFromGoogle(type, place);
                Object.keys(address).forEach(function (key, index) {
                    setFieldValue(key, address[key]);
                });
                setAddress(__assign(__assign({}, address), { autoCompleteAddress: autoCompleteAddress, addressSelected: true, manualAddressEntry: true }));
            });
        }
    };
    var handleManualEntryClick = function (e) {
        if (e && e.preventDefault)
            e.preventDefault();
        setAddress(__assign(__assign({}, address), { manualAddressEntry: true }));
    };
    var initMaps = function () {
        setGmapsLoaded(true);
        var addressUri = (function (name, url) {
            if (url === void 0) { url = window.location.href; }
            var newName = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp("[?&]" + newName + "(=([^&#]*)|&|#|$)");
            var results = regex.exec(url);
            if (!results) {
                return null;
            }
            if (!results[2]) {
                return '';
            }
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        })('address');
        handleAddressSelect(addressUri);
    };
    var insertGoogleMapsScript = function () {
        var googleApiKey = window.GOOGLE_API_KEY || '';
        var gmapsElemId = 'googleMapsScript';
        var existingScriptElem = document.getElementById(gmapsElemId);
        if (existingScriptElem) {
            initMaps();
            return;
        }
        if (googleApiKey && !document.querySelector(gmapsElemId)) {
            var gmapScriptEl = document.createElement('script');
            gmapScriptEl.id = 'googleMapsScript';
            gmapScriptEl.src = "https://maps.googleapis.com/maps/api/js?key=" + googleApiKey + "&libraries=places&callback=initMaps";
            document
                .querySelector('body')
                .insertAdjacentElement('beforeend', gmapScriptEl);
        }
    };
    var autocompleteOptions = {
        componentRestrictions: { country: ['au'] },
    };
    return (React.createElement("div", { className: "address-form address-form-" + type },
        React.createElement("h3", null, label),
        React.createElement("div", null,
            React.createElement("div", { className: "row w-100" },
                React.createElement("div", { className: "col-lg-12" }, gmapsLoaded && (React.createElement(PlacesAutocomplete, { value: address.autoCompleteAddress ? address.autoCompleteAddress : '', onChange: handleAddressChange, onSelect: handleAddressSelect, highlightFirstSuggestion: true, searchOptions: autocompleteOptions }, function (_a) {
                    var getInputProps = _a.getInputProps, suggestions = _a.suggestions, getSuggestionItemProps = _a.getSuggestionItemProps;
                    return (React.createElement("div", null,
                        React.createElement("input", __assign({}, getInputProps({
                            'aria-labelledby': 'address-label',
                            autoFocus: true,
                            className: 'form-control',
                            onBlur: function (e) { return handleAddressSelect(e.currentTarget.value); },
                            placeholder: 'Enter your address here',
                        }))),
                        React.createElement("div", { className: "autocomplete-dropdown-container" }, suggestions.map(function (suggestion, i) {
                            var className = suggestion.active
                                ? 'suggestion-item--active'
                                : 'suggestion-item';
                            return (React.createElement("div", __assign({ key: i }, getSuggestionItemProps(suggestion, {
                                className: className,
                            })),
                                React.createElement("span", null, suggestion.description)));
                        }))));
                })))),
            React.createElement("br", null),
            !address.manualAddressEntry && (React.createElement("div", { className: "row w-100" },
                React.createElement("div", { className: "col-lg-12 text-center" },
                    React.createElement("p", null,
                        "Can't find your address? ",
                        React.createElement("a", { href: "#", onClick: handleManualEntryClick }, "Enter it manually"))))),
            address.manualAddressEntry && (React.createElement(React.Fragment, null,
                React.createElement("hr", null),
                React.createElement("div", { className: "row w-100 form-group" },
                    React.createElement("div", { className: "col-lg-3" },
                        React.createElement("label", { htmlFor: type + "AddressLevelType" }, "Level Type"),
                        React.createElement("select", { className: "form-control shadow-alt", id: type + "AddressLevelType", name: type + "AddressLevelType", value: values[type + "AddressLevelType"], onChange: function (e) {
                                setFieldValue(e.currentTarget.name, e.currentTarget.value);
                            } },
                            React.createElement("option", { value: "" }),
                            levelTypes.map(function (type) { return (React.createElement("option", { key: type.abbreviation, value: type.name }, type.name)); })),
                        React.createElement(Error, { name: type + "AddressLevelType" })),
                    React.createElement("div", { className: "col-lg-3" },
                        React.createElement("label", { htmlFor: type + "AddressLevelNumber" }, "Level number"),
                        React.createElement("input", { type: "text", className: "form-control shadow-alt", id: type + "AddressLevelNumber", name: type + "AddressLevelNumber", value: values[type + "AddressLevelNumber"], onChange: function (e) {
                                setFieldValue(e.currentTarget.name, e.currentTarget.value);
                            } })),
                    React.createElement("div", { className: "col-lg-3" },
                        React.createElement("label", { htmlFor: type + "AddressUnitType" }, "Unit Types"),
                        React.createElement("select", { className: "form-control shadow-alt", id: type + "AddressUnitType", name: type + "AddressUnitType", value: values[type + "AddressUnitType"], onChange: function (e) {
                                setFieldValue(e.currentTarget.name, e.currentTarget.value);
                            } },
                            React.createElement("option", { value: "" }),
                            unitTypes.map(function (type) { return (React.createElement("option", { key: type.abbreviation, value: type.name }, type.name)); }))),
                    React.createElement("div", { className: "col-lg-3" },
                        React.createElement("label", { htmlFor: type + "AddressUnitNumber" }, "Unit number"),
                        React.createElement("input", { type: "text", className: "form-control shadow-alt " + (errors[type + "AddressUnitNumber"] &&
                                touched[type + "AddressUnitNumber"] &&
                                'error'), id: type + "AddressUnitNumber", name: type + "AddressUnitNumber", value: values[type + "AddressUnitNumber"], onChange: function (e) {
                                setFieldValue(e.currentTarget.name, e.currentTarget.value);
                            } }),
                        React.createElement(Error, { name: type + "AddressUnitNumber" }))),
                React.createElement("div", { className: "row w-100 form-group" },
                    React.createElement("div", { className: "col-lg-3" },
                        React.createElement("label", { htmlFor: type + "AddressStreetNumber" }, "Street number"),
                        React.createElement(Field, { id: type + "AddressStreetNumber", name: type + "AddressStreetNumber", component: "input", className: "form-control shadow-alt " + (errors[type + "AddressStreetNumber"] &&
                                touched[type + "AddressStreetNumber"] &&
                                'error'), value: values[type + "AddressStreetNumber"], onChange: function (e) {
                                setFieldValue(e.currentTarget.name, e.currentTarget.value);
                            } }),
                        React.createElement(Error, { name: type + "AddressStreetNumber" })),
                    React.createElement("div", { className: "col-lg-6" },
                        React.createElement("label", { htmlFor: type + "AddressStreetName" }, "Street name"),
                        React.createElement("input", { type: "text", className: "form-control shadow-alt " + (errors[type + "AddressStreetName"] &&
                                touched[type + "AddressStreetName"] &&
                                'error'), id: type + "AddressStreetName", name: type + "AddressStreetName", value: values[type + "AddressStreetName"], onChange: function (e) {
                                setFieldValue(e.currentTarget.name, e.currentTarget.value);
                            } }),
                        React.createElement(Error, { name: type + "AddressStreetName" })),
                    React.createElement("div", { className: "col-lg-3" },
                        React.createElement("label", { htmlFor: type + "AddressStreetType" }, "Street type"),
                        React.createElement("select", { className: "form-control shadow-alt " + (errors[type + "AddressStreetType"] &&
                                touched[type + "AddressStreetType"] &&
                                'error'), id: type + "AddressStreetType", name: type + "AddressStreetType", value: values[type + "AddressStreetType"], onChange: function (e) {
                                setFieldValue(e.currentTarget.name, e.currentTarget.value);
                            } },
                            React.createElement("option", { value: "" }),
                            streetTypes.map(function (type) { return (React.createElement("option", { key: type.abbreviation, value: type.name }, type.name.replace(/_/g, ' '))); })),
                        React.createElement(Error, { name: type + "AddressStreetType" }))),
                React.createElement("div", { className: "row w-100 form-group" },
                    React.createElement("div", { className: "col-lg-4" },
                        React.createElement("label", { htmlFor: type + "AddressSuburb" }, "Suburb"),
                        React.createElement("input", { type: "text", className: "form-control shadow-alt " + (errors[type + "AddressSuburb"] &&
                                touched[type + "AddressSuburb"] &&
                                'error'), id: type + "AddressSuburb", name: type + "AddressSuburb", value: values[type + "AddressSuburb"], onChange: function (e) {
                                setFieldValue(e.currentTarget.name, e.currentTarget.value);
                            } }),
                        React.createElement(Error, { name: type + "AddressSuburb" })),
                    React.createElement("div", { className: "col-lg-4" },
                        React.createElement("label", null, "State"),
                        React.createElement("select", { className: "form-control shadow-alt " + (errors[type + "AddressState"] &&
                                touched[type + "AddressState"] &&
                                'error'), id: type + "AddressState", name: type + "AddressState", value: values[type + "AddressState"], onChange: function (e) {
                                setFieldValue(e.currentTarget.name, e.currentTarget.value);
                            } },
                            React.createElement("option", { value: "" }),
                            states.map(function (state) { return (React.createElement("option", { key: state.abbreviation, value: state.abbreviation }, state.name)); }))),
                    React.createElement("div", { className: "col-lg-4" },
                        React.createElement("label", { htmlFor: type + "AddressPostcode" }, "Postcode"),
                        React.createElement("input", { type: "text", className: "form-control shadow-alt " + (errors[type + "AddressPostcode"] &&
                                touched[type + "AddressPostcode"] &&
                                'error'), id: type + "AddressPostcode", name: type + "AddressPostcode", value: values[type + "AddressPostcode"], onChange: function (e) {
                                setFieldValue(e.currentTarget.name, e.currentTarget.value.trim());
                            } }))))))));
}
//# sourceMappingURL=CheckAddress.js.map